var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 981,
    height: 616,
    viewBox: "0 0 981 616",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_18)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 981,
    height: 616,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 981,
    height: 616,
    fill: "url(#paint0_linear_2_18)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 138,
    r: 89,
    fill: "white",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 482,
    r: 56,
    fill: "white",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 724.5,
    cy: 413.5,
    r: 37.5,
    fill: "white",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.47 34.4742L848.751 155.209L671.762 145.727L766.47 34.4742Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.5 75L320.244 120.75H258.756L289.5 75Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.642 294.145L508.157 349.959L394.563 407.371L408.642 294.145Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.583 428.147L203.479 457.015L89.8857 514.428L117.583 428.147Z",
    fill: "white",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.251 426.732L660.519 531.028L535.166 508.975L614.251 426.732Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.073,
    y: 137.635,
    width: 71.2072,
    height: 31,
    transform: "rotate(32.3778 564.073 137.635)",
    fill: "white",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: -12.8532,
    y: 256.522,
    width: 144.526,
    height: 62.9191,
    transform: "rotate(32.3778 -12.8532 256.522)",
    fill: "white",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.754,
    y: 418.49,
    width: 47.8173,
    height: 25.6835,
    transform: "rotate(32.3778 267.754 418.49)",
    fill: "white",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 955.6,
    y: 324,
    width: 30.611,
    height: 31,
    transform: "rotate(32.3778 955.6 324)",
    fill: "white",
    fillOpacity: 0.19
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_18",
    x1: 963.5,
    y1: 39,
    x2: -0.0000289048,
    y2: 426.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0174071,
    stopColor: "#3AA9AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B78F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 981,
    height: 616,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.fbc6160a6dfc479859ea0bbb96a10b5a.svg";
export { ForwardRef as ReactComponent };